/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'

const PropertiesLazyRouteImport = createFileRoute('/properties')()
const ProfileLazyRouteImport = createFileRoute('/profile')()
const ImportExportLazyRouteImport = createFileRoute('/import-export')()
const DealsLazyRouteImport = createFileRoute('/deals')()
const DashboardLazyRouteImport = createFileRoute('/dashboard')()
const ContactsLazyRouteImport = createFileRoute('/contacts')()
const CalendarLazyRouteImport = createFileRoute('/calendar')()
const ApprovalsLazyRouteImport = createFileRoute('/approvals')()
const AiConsoleLazyRouteImport = createFileRoute('/ai-console')()
const AdminLazyRouteImport = createFileRoute('/admin')()
const AccountsLazyRouteImport = createFileRoute('/accounts')()

const PropertiesLazyRoute = PropertiesLazyRouteImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/properties.lazy').then((d) => d.Route))
const ProfileLazyRoute = ProfileLazyRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/profile.lazy').then((d) => d.Route))
const ImportExportLazyRoute = ImportExportLazyRouteImport.update({
  id: '/import-export',
  path: '/import-export',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/import-export.lazy').then((d) => d.Route))
const DealsLazyRoute = DealsLazyRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/deals.lazy').then((d) => d.Route))
const DashboardLazyRoute = DashboardLazyRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dashboard.lazy').then((d) => d.Route))
const ContactsLazyRoute = ContactsLazyRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/contacts.lazy').then((d) => d.Route))
const CalendarLazyRoute = CalendarLazyRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/calendar.lazy').then((d) => d.Route))
const ApprovalsLazyRoute = ApprovalsLazyRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/approvals.lazy').then((d) => d.Route))
const AiConsoleLazyRoute = AiConsoleLazyRouteImport.update({
  id: '/ai-console',
  path: '/ai-console',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/ai-console.lazy').then((d) => d.Route))
const AdminLazyRoute = AdminLazyRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const AccountsLazyRoute = AccountsLazyRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/accounts.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsLazyRoute
  '/admin': typeof AdminLazyRoute
  '/ai-console': typeof AiConsoleLazyRoute
  '/approvals': typeof ApprovalsLazyRoute
  '/calendar': typeof CalendarLazyRoute
  '/contacts': typeof ContactsLazyRoute
  '/dashboard': typeof DashboardLazyRoute
  '/deals': typeof DealsLazyRoute
  '/import-export': typeof ImportExportLazyRoute
  '/profile': typeof ProfileLazyRoute
  '/properties': typeof PropertiesLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accounts': typeof AccountsLazyRoute
  '/admin': typeof AdminLazyRoute
  '/ai-console': typeof AiConsoleLazyRoute
  '/approvals': typeof ApprovalsLazyRoute
  '/calendar': typeof CalendarLazyRoute
  '/contacts': typeof ContactsLazyRoute
  '/dashboard': typeof DashboardLazyRoute
  '/deals': typeof DealsLazyRoute
  '/import-export': typeof ImportExportLazyRoute
  '/profile': typeof ProfileLazyRoute
  '/properties': typeof PropertiesLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accounts': typeof AccountsLazyRoute
  '/admin': typeof AdminLazyRoute
  '/ai-console': typeof AiConsoleLazyRoute
  '/approvals': typeof ApprovalsLazyRoute
  '/calendar': typeof CalendarLazyRoute
  '/contacts': typeof ContactsLazyRoute
  '/dashboard': typeof DashboardLazyRoute
  '/deals': typeof DealsLazyRoute
  '/import-export': typeof ImportExportLazyRoute
  '/profile': typeof ProfileLazyRoute
  '/properties': typeof PropertiesLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accounts'
    | '/admin'
    | '/ai-console'
    | '/approvals'
    | '/calendar'
    | '/contacts'
    | '/dashboard'
    | '/deals'
    | '/import-export'
    | '/profile'
    | '/properties'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accounts'
    | '/admin'
    | '/ai-console'
    | '/approvals'
    | '/calendar'
    | '/contacts'
    | '/dashboard'
    | '/deals'
    | '/import-export'
    | '/profile'
    | '/properties'
  id:
    | '__root__'
    | '/'
    | '/accounts'
    | '/admin'
    | '/ai-console'
    | '/approvals'
    | '/calendar'
    | '/contacts'
    | '/dashboard'
    | '/deals'
    | '/import-export'
    | '/profile'
    | '/properties'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountsLazyRoute: typeof AccountsLazyRoute
  AdminLazyRoute: typeof AdminLazyRoute
  AiConsoleLazyRoute: typeof AiConsoleLazyRoute
  ApprovalsLazyRoute: typeof ApprovalsLazyRoute
  CalendarLazyRoute: typeof CalendarLazyRoute
  ContactsLazyRoute: typeof ContactsLazyRoute
  DashboardLazyRoute: typeof DashboardLazyRoute
  DealsLazyRoute: typeof DealsLazyRoute
  ImportExportLazyRoute: typeof ImportExportLazyRoute
  ProfileLazyRoute: typeof ProfileLazyRoute
  PropertiesLazyRoute: typeof PropertiesLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/properties': {
      id: '/properties'
      path: '/properties'
      fullPath: '/properties'
      preLoaderRoute: typeof PropertiesLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import-export': {
      id: '/import-export'
      path: '/import-export'
      fullPath: '/import-export'
      preLoaderRoute: typeof ImportExportLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals': {
      id: '/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof DealsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts': {
      id: '/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/approvals': {
      id: '/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ApprovalsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-console': {
      id: '/ai-console'
      path: '/ai-console'
      fullPath: '/ai-console'
      preLoaderRoute: typeof AiConsoleLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accounts': {
      id: '/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AccountsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsLazyRoute: AccountsLazyRoute,
  AdminLazyRoute: AdminLazyRoute,
  AiConsoleLazyRoute: AiConsoleLazyRoute,
  ApprovalsLazyRoute: ApprovalsLazyRoute,
  CalendarLazyRoute: CalendarLazyRoute,
  ContactsLazyRoute: ContactsLazyRoute,
  DashboardLazyRoute: DashboardLazyRoute,
  DealsLazyRoute: DealsLazyRoute,
  ImportExportLazyRoute: ImportExportLazyRoute,
  ProfileLazyRoute: ProfileLazyRoute,
  PropertiesLazyRoute: PropertiesLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
